'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _colors = require('HubStyleTokens/colors');

var _UISelect = require('UIComponents/input/UISelect');

var _UISelect2 = _interopRequireDefault(_UISelect);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _H = require('UIComponents/elements/headings/H3');

var _H2 = _interopRequireDefault(_H);

var _UIScrollContainer = require('UIComponents/scroll/UIScrollContainer');

var _UIScrollContainer2 = _interopRequireDefault(_UIScrollContainer);

var _Terms = require('self-service-api/constants/Terms');

var _MerchandiseSelectors = require('pricing-pages-unified-ui/selectors/MerchandiseSelectors');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _GrowthSuiteCatalogEditionHeader = require('pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogEditionHeader');

var _GrowthSuiteCatalogEditionHeader2 = _interopRequireDefault(_GrowthSuiteCatalogEditionHeader);

var _GrowthSuiteCatalogFeaturesTable = require('pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogFeaturesTable');

var _GrowthSuiteCatalogFeaturesTable2 = _interopRequireDefault(_GrowthSuiteCatalogFeaturesTable);

var _FooterMicrocopy = require('pricing-pages-unified-ui/components/common/FooterMicrocopy');

var _FooterMicrocopy2 = _interopRequireDefault(_FooterMicrocopy);

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _GrowthSuiteEditionTermIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionTermIdMap');

var _GrowthSuiteEditionTermIdMap2 = _interopRequireDefault(_GrowthSuiteEditionTermIdMap);

var _Hubs = require('self-service-api/constants/Hubs');

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MODAL_WIDTH = 1200;
var HEADER_HEIGHT = 128;
var MODAL_TOP_MARGIN = 60;
var MODAL_BOTTOM_MARGIN = 47;

var growthSuiteHubs = ['marketing', 'sales', 'service'];
var growthSuiteEditions = ['starter', 'professional', 'enterprise'];

var ModalHeader = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteCatalogModal__ModalHeader'
})(['text-align:center;z-index:100;background-color:', ';padding:15px 0;& > h3{margin:0;}img{height:20px;}'], _colors.GYPSUM);

var PricingContainer = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteCatalogModal__PricingContainer'
})(['margin:0 auto;']);

var Price = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteCatalogModal__Price'
})(['font-size:20px;color:', ';margin-right:8px;font-weight:600;display:inline-block;'], _colors.OZ);

var CrossedOutPrice = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'GrowthSuiteCatalogModal__CrossedOutPrice'
})(['color:', ';font-size:16px;line-height:27px;text-decoration:line-through;'], _colors.PANTERA);

var CrossOutPerMonth = _styledComponents2.default.span.withConfig({
  displayName: 'GrowthSuiteCatalogModal__CrossOutPerMonth'
})(['font-size:16px;line-height:27px;text-decoration:line-through;']);

var StyledSelect = (0, _styledComponents2.default)(_UISelect2.default).withConfig({
  displayName: 'GrowthSuiteCatalogModal__StyledSelect'
})(['width:fit-content;margin:8px auto 16px;font-size:26px;.private-dropdown__caret{font-size:20px;color:', ';margin-left:8px;}.growth-suite-bold{font-weight:700;}'], _colors.CALYPSO);

var GrowthSuiteCatalogModal = function (_React$Component) {
  _inherits(GrowthSuiteCatalogModal, _React$Component);

  function GrowthSuiteCatalogModal(props) {
    _classCallCheck(this, GrowthSuiteCatalogModal);

    var _this = _possibleConstructorReturn(this, (GrowthSuiteCatalogModal.__proto__ || Object.getPrototypeOf(GrowthSuiteCatalogModal)).call(this, props));

    _this.state = {
      activeGrowthSuiteEdition: _this.props.edition
    };
    return _this;
  }

  _createClass(GrowthSuiteCatalogModal, [{
    key: 'getOption',
    value: function getOption(edition) {
      var text = _react2.default.createElement(_FormattedHTMLMessage2.default, {
        message: 'pricingPage.pages.growthSuite.catalogModal.' + edition
      });
      var option = { dropdownText: text, buttonText: text, value: edition };

      return option;
    }
  }, {
    key: 'getPricingInfo',
    value: function getPricingInfo() {
      var pricingDependencies = this.props.pricingDependencies;
      var activeGrowthSuiteEdition = this.state.activeGrowthSuiteEdition;

      var defaultTerm = _GrowthSuiteEditionTermIdMap2.default[activeGrowthSuiteEdition][_Terms.MONTHLY] || _GrowthSuiteEditionTermIdMap2.default[activeGrowthSuiteEdition][_Terms.ANNUAL];

      return (0, _pricingUtils.calculateBundlePrice)({
        marketingPlanSelected: _SuiteEditionMerchIdMap2.default[activeGrowthSuiteEdition][_Hubs.HUB_MARKETING],
        salesPlanSelected: _SuiteEditionMerchIdMap2.default[activeGrowthSuiteEdition][_Hubs.HUB_SALES],
        servicePlanSelected: _SuiteEditionMerchIdMap2.default[activeGrowthSuiteEdition][_Hubs.HUB_SERVICE],
        term: defaultTerm,
        pricingDependencies: pricingDependencies,
        isGrowthSuite: true
      });
    }
  }, {
    key: 'renderGrowthSuiteEditionSelector',
    value: function renderGrowthSuiteEditionSelector() {
      var _this2 = this;

      return _react2.default.createElement(StyledSelect, {
        buttonUse: 'unstyled',
        onChange: function onChange(evt) {
          return _this2.setState({ activeGrowthSuiteEdition: evt.target.value });
        },
        options: growthSuiteEditions.map(function (edition) {
          return _this2.getOption(edition);
        }),
        value: this.state.activeGrowthSuiteEdition,
        searchable: false,
        menuWidth: 'auto'
      });
    }
  }, {
    key: 'renderModalHeader',
    value: function renderModalHeader() {
      var _props = this.props,
          onCloseClick = _props.onCloseClick,
          currencyCode = _props.currencyCode;

      var pricingInfo = this.getPricingInfo();

      return _react2.default.createElement(
        ModalHeader,
        null,
        _react2.default.createElement(
          _H2.default,
          { className: 'display-inline' },
          this.renderGrowthSuiteEditionSelector(),
          _react2.default.createElement(
            PricingContainer,
            null,
            _react2.default.createElement(
              Price,
              null,
              _react2.default.createElement(_PriceDisplay2.default, {
                price: pricingInfo.monthly.calculatedPrice,
                currencyCode: currencyCode
              }),
              _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.priceDisplay.perMonth' })
            ),
            _react2.default.createElement(CrossedOutPrice, {
              price: pricingInfo.monthly.fullPrice,
              currencyCode: currencyCode
            }),
            _react2.default.createElement(
              CrossOutPerMonth,
              null,
              _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.priceDisplay.perMonth' })
            )
          )
        ),
        _react2.default.createElement(_UIDialogCloseButton2.default, { onClick: (0, _partial2.default)(onCloseClick) })
      );
    }
  }, {
    key: 'renderGrowthHubEditionTable',
    value: function renderGrowthHubEditionTable(hub) {
      var _props2 = this.props,
          currencyCode = _props2.currencyCode,
          products = _props2.products;
      var activeGrowthSuiteEdition = this.state.activeGrowthSuiteEdition;


      return _react2.default.createElement(
        _react2.default.Fragment,
        { key: hub },
        _react2.default.createElement(_GrowthSuiteCatalogEditionHeader2.default, {
          currencyCode: currencyCode,
          edition: activeGrowthSuiteEdition,
          products: products,
          hub: hub
        }),
        _react2.default.createElement(_GrowthSuiteCatalogFeaturesTable2.default, {
          hub: hub,
          edition: activeGrowthSuiteEdition
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var onCloseClick = this.props.onCloseClick;


      return _react2.default.createElement(
        _UIModal2.default,
        {
          use: 'conversational',
          width: MODAL_WIDTH,
          style: { minWidth: '900px' },
          onOverlayClick: onCloseClick
        },
        this.renderModalHeader(),
        _react2.default.createElement(
          _UIScrollContainer2.default,
          {
            maxHeight: 'calc(100vh - ' + (HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN) + 'px)',
            scrollDirection: 'vertical'
          },
          growthSuiteHubs.map(function (hub) {
            return _this3.renderGrowthHubEditionTable(hub);
          }),
          _react2.default.createElement(_FooterMicrocopy2.default, null)
        )
      );
    }
  }]);

  return GrowthSuiteCatalogModal;
}(_react2.default.Component);

GrowthSuiteCatalogModal.propTypes = {
  currencyCode: _react.PropTypes.string.isRequired,
  edition: _react.PropTypes.string.isRequired,
  products: _react.PropTypes.object.isRequired,
  onCloseClick: _react.PropTypes.func.isRequired,
  pricingDependencies: _react.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(GrowthSuiteCatalogModal);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-catalog/GrowthSuiteCatalogModal.js
// module id = 776
// module chunks = 3 4